/**
 * MindState — Omnibus relocate + persist on variant change
 *
 * Cel: paragraph "Najniższa cena z 30 dni: XXX PLN" (renderowany
 * przez zewnętrzną app/integration jako .omnibus-price) ma być
 * zawsze widoczny pod ceną w PDP, niezależnie od variant change.
 *
 * Mechanizm 3-warstwowy:
 * 1. Initial relocate: znajdź .omnibus-price, skopiuj do <product-price>
 *    jako .ms-omnibus-relocated. Zapamiętaj tekst.
 * 2. MutationObserver na <product-price>: jeśli po DOM replace
 *    .ms-omnibus-relocated zniknął, ponownie wstaw cached tekst.
 * 3. Fallback retry: po variant change (event listener) sprawdź
 *    obecność z opóźnieniem 150/400/900ms — na wypadek gdy
 *    observer się nie odpalił.
 *
 * Wymóg prawny: Dyrektywa Omnibus EU / UOKiK — najniższa cena
 * z 30 dni musi być widoczna dla każdego wariantu z promocją.
 */
(function () {
  'use strict';

  var STATE = {
    cachedHTML: null,    // pełna treść HTML .omnibus-price (na wypadek formatowania)
    cachedText: null,    // fallback plain text
    productPrice: null   // referencja do <product-price> elementu
  };

  /**
   * Znajdź .omnibus-price w DOM (oryginał z app)
   */
  function findOmnibusOriginal() {
    return document.querySelector('.omnibus-price:not(.ms-omnibus-relocated .omnibus-price)');
  }

  /**
   * Wstaw Omnibus do <product-price>. Idempotent — jeśli już
   * istnieje, nic nie robi.
   */
  function injectOmnibus() {
    if (!STATE.productPrice) {
      STATE.productPrice = document.querySelector('product-price');
    }
    if (!STATE.productPrice) return false;

    // Już jest? Skip.
    if (STATE.productPrice.querySelector('.ms-omnibus-relocated')) {
      return true;
    }

    // Mamy cached HTML?
    if (!STATE.cachedHTML) {
      // Pierwszy run — szukaj oryginału z app
      var original = findOmnibusOriginal();
      if (!original) return false;
      STATE.cachedHTML = original.outerHTML;
      STATE.cachedText = original.textContent.trim();
    }

    // Stwórz wrapper z klasą ms-omnibus-relocated + insert cached HTML
    var wrapper = document.createElement('div');
    wrapper.className = 'ms-omnibus-relocated';
    wrapper.innerHTML = STATE.cachedHTML;

    STATE.productPrice.appendChild(wrapper);
    return true;
  }

  /**
   * MutationObserver na <product-price> — re-inject po DOM replace
   */
  function setupObserver() {
    STATE.productPrice = document.querySelector('product-price');
    if (!STATE.productPrice) return;

    var observer = new MutationObserver(function () {
      // Sprawdź czy .ms-omnibus-relocated dalej istnieje
      if (!STATE.productPrice.querySelector('.ms-omnibus-relocated')) {
        // Zniknął — re-inject
        injectOmnibus();
      }
    });

    observer.observe(STATE.productPrice, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Fallback retry po variant change — na wypadek gdy observer
   * się nie odpalił (race condition po AJAX replace innerHTML).
   */
  function setupVariantChangeListener() {
    // Shopify variant change events (różne wzorce w różnych themach)
    var events = ['variant:change', 'variantChange', 'change'];

    events.forEach(function (eventName) {
      document.addEventListener(eventName, function (e) {
        // Tylko jeśli event pochodzi z variant-picker
        if (eventName === 'change' && !(e.target.closest && e.target.closest('variant-picker'))) {
          return;
        }

        // Retry 150ms, 400ms, 900ms
        [150, 400, 900].forEach(function (delay) {
          setTimeout(injectOmnibus, delay);
        });
      }, true);
    });
  }

  /**
   * Init — uruchom wszystko
   */
  function init() {
    // Pierwszy inject
    injectOmnibus();

    // Observer + listeners
    setupObserver();
    setupVariantChangeListener();
  }

  // Wait for DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
